var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridRoundDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6C4 7.10457 4.89543 8 6 8C7.10457 8 8 7.10457 8 6C8 4.89543 7.10457 4 6 4C4.89543 4 4 4.89543 4 6Z",
    fill: "#2C303B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18C10 19.1046 10.8954 20 12 20C13.1046 20 14 19.1046 14 18C14 16.8954 13.1046 16 12 16C10.8954 16 10 16.8954 10 18Z",
    fill: "#2C303B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20C4.89543 20 4 19.1046 4 18C4 16.8954 4.89543 16 6 16C7.10457 16 8 16.8954 8 18C8 19.1046 7.10457 20 6 20Z",
    fill: "#2C303B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12C4 13.1046 4.89543 14 6 14C7.10457 14 8 13.1046 8 12C8 10.8954 7.10457 10 6 10C4.89543 10 4 10.8954 4 12Z",
    fill: "#2C303B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14Z",
    fill: "#2C303B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 4C16.8954 4 16 4.89543 16 6C16 7.10457 16.8954 8 18 8C19.1046 8 20 7.10457 20 6C20 4.89543 19.1046 4 18 4Z",
    fill: "#2C303B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8C10.8954 8 10 7.10457 10 6C10 4.89543 10.8954 4 12 4C13.1046 4 14 4.89543 14 6C14 7.10457 13.1046 8 12 8Z",
    fill: "#2C303B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12C16 13.1046 16.8954 14 18 14C19.1046 14 20 13.1046 20 12C20 10.8954 19.1046 10 18 10C16.8954 10 16 10.8954 16 12Z",
    fill: "#2C303B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20C16.8954 20 16 19.1046 16 18C16 16.8954 16.8954 16 18 16C19.1046 16 20 16.8954 20 18C20 19.1046 19.1046 20 18 20Z",
    fill: "#2C303B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridRoundDark);
export default __webpack_public_path__ + "static/media/grid-round-dark.216e6e3885caf5d81053806abb78c9b4.svg";
export { ForwardRef as ReactComponent };